// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__ryoAu","notes":"Notes_notes__3bHCM"};